module.exports = __webpack_public_path__ + "img/partner_icon24.574e8786.png";